import { CalendarDays, LayoutList, SlidersHorizontal } from 'lucide-react';
import { ADMIN_GUARD } from '../admin-guard';
import { CONTEXTS, lazyView, type FeatureManifest } from '@/app/registry';
import { adminUserTestsRoutes } from './routes';
import { USER_TEST_PLANNING_ITEM_TAB } from './userTestPanels';

/** Mini-formulaire de l'évaluation sélectionnée — même onglet en création et en détail. */
const planningItemTab = {
  id: USER_TEST_PLANNING_ITEM_TAB,
  label: 'Évaluation',
  icon: CalendarDays,
  hideInTabBar: true,
  view: lazyView(
    () => import('../views/AdminUserTestPlanningItemView'),
    'AdminUserTestPlanningItemView',
  ),
};

export const adminUserTestsManifest: FeatureManifest = {
  id: 'admin-user-tests',
  contexts: [
    CONTEXTS.ADMIN_USER_TESTS,
    CONTEXTS.ADMIN_USER_TEST_FORM,
    CONTEXTS.ADMIN_USER_TEST_DETAIL,
  ],

  routes: [
    { routes: adminUserTestsRoutes, errorFallbackLabel: 'Assignations', guard: ADMIN_GUARD },
  ],

  centerView: {
    [CONTEXTS.ADMIN_USER_TESTS]: lazyView(
      () => import('../views/AdminUserTestsListView'),
      'AdminUserTestsListView',
    ),
    [CONTEXTS.ADMIN_USER_TEST_FORM]: lazyView(
      () => import('../views/AdminUserTestFormView'),
      'AdminUserTestFormView',
    ),
    [CONTEXTS.ADMIN_USER_TEST_DETAIL]: lazyView(
      () => import('../views/AdminUserTestDetailView'),
      'AdminUserTestDetailView',
    ),
  },

  panels: {
    left: {
      tabs: {
        [CONTEXTS.ADMIN_USER_TESTS]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
          {
            id: 'admin-user-test-filters',
            label: 'Filtres',
            icon: SlidersHorizontal,
            view: lazyView(
              () => import('../views/AdminUserTestFiltersView'),
              'AdminUserTestFiltersView',
            ),
          },
        ],
        [CONTEXTS.ADMIN_USER_TEST_FORM]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
        [CONTEXTS.ADMIN_USER_TEST_DETAIL]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
      },
    },
    right: {
      tabs: {
        [CONTEXTS.ADMIN_USER_TEST_FORM]: [planningItemTab],
        [CONTEXTS.ADMIN_USER_TEST_DETAIL]: [planningItemTab],
      },
    },
  },
  enabledWhen: {
    roles: ['admin'],
  },

  panelRequirements: {
    [CONTEXTS.ADMIN_USER_TESTS]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
    [CONTEXTS.ADMIN_USER_TEST_FORM]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      // Comme en détail : sans sélection, il invite à choisir un test puis un bloc.
      right: { open: true, defaultActiveTab: USER_TEST_PLANNING_ITEM_TAB, reopenOnVisit: true },
    },
    [CONTEXTS.ADMIN_USER_TEST_DETAIL]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      // Ouvert à chaque arrivée (même s'il a été fermé à la visite précédente) :
      // sans sélection, il invite à cliquer un bloc du planning.
      right: { open: true, defaultActiveTab: USER_TEST_PLANNING_ITEM_TAB, reopenOnVisit: true },
    },
  },
};
